import React, { useEffect, useState } from 'react';
import { Mic } from 'lucide-react';
import { lowestHourlyRate } from '../lib/bookingRules';

// Mobile-only sticky CTA. Hidden at the very top and while the booking form is on screen.
export const StickyBookBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [bookingVisible, setBookingVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 350);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    const target = document.getElementById('booking');
    let io;
    if (target && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(([entry]) => setBookingVisible(entry.isIntersecting), { threshold: 0.05 });
      io.observe(target);
    }
    return () => { window.removeEventListener('scroll', onScroll); io && io.disconnect(); };
  }, []);

  if (!scrolled || bookingVisible) return null;

  return (
    <div className="md:hidden fixed bottom-4 left-3 right-24 z-[45]" style={{ marginBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      <a
        href="/book"
        data-testid="sticky-book-btn"
        className="flex items-center justify-center gap-2 w-full rounded-full bg-gradient-to-r from-purple-600 to-blue-600 py-3.5 px-4 text-white font-bold text-sm tracking-wide shadow-2xl shadow-purple-900/60 active:scale-[0.98] transition-transform"
      >
        <Mic size={16} />
        <span className="whitespace-nowrap">BOOK A SESSION · ${lowestHourlyRate}/HR+</span>
      </a>
    </div>
  );
};

export default StickyBookBar;
